<script>
    import {getPercentage, getPercentageFB} from "../utils";

    export let hasNotifications = false;

    let notifications = [];

    import {getAlerts, getUnviewedAlerts} from "../firestore";
    import {take} from "rxjs/operators";

    refreshNotifications();

    function refreshNotifications() {
        notifications = [];
        hasNotifications = false;

        getUnviewedAlerts().subscribe({
            next: alert => {
                let description_details = alert.alert_details.level === "DANGER" ? "Critical Level" : "Warning Level";
                let description = getPercentageFB(parseFloat(alert.gqlsensor.lastMessage.value), alert.sensor_details).toFixed(0) + "% - " + description_details;

                notifications = [...notifications, {
                    title: alert.sensor_details.name,
                    description: description,
                    time: new Date(alert.gqlsensor.lastMessage.date).toLocaleString(),
                    icon: "dist/img/silot_icon_white.png",
                    state: alert.alert_details.level.toLowerCase(),
                    url: "#/equipment/" + alert.gqlsensor._id,
                    id: alert.id,
                    viewed: alert.viewed,
                }];

                hasNotifications = true;
            },
            complete: () => {
                if (notifications.length >= 10) return;

                getAlerts().pipe(
                        take(10 - notifications.length)
                ).subscribe(alert => {
                    let description_details = alert.alert_details.level === "DANGER" ? "Critical Level" : "Warning Level";
                    let description = getPercentageFB(parseFloat(alert.gqlsensor.lastMessage.value), alert.sensor_details).toFixed(0) + "% - " + description_details;

                    notifications = [...notifications, {
                        title: alert.sensor_details.name,
                        description: description,
                        time: new Date(alert.gqlsensor.last_message.date).toLocaleString(),
                        icon: "dist/img/silot_icon_white.png",
                        state: alert.alert_details.level.toLowerCase(),
                        url: "#/equipment/" + alert.gqlsensor._id,
                        id: alert.id,
                        viewed: alert.viewed,
                    }];
                })
            }
        });
    }

    function changeViewed(id) {
        firebase.firestore().collection("alerts").doc(id).set({viewed: true}, {merge: true});
        refreshNotifications();
    }
</script>

<li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle text-muted text-muted waves-effect waves-dark" href="" data-toggle="dropdown"
       aria-haspopup="true" aria-expanded="false" title="Notifications"> <i class="mdi mdi-bell"></i>
        <div class="notify">
            {#if hasNotifications}
                <span class="heartbit"></span>
                <span class="point"></span>
            {/if}
        </div>
    </a>
    <div class="dropdown-menu dropdown-menu-right mailbox scale-up">
        <ul>
            <li>
                <div class="drop-title">Notifications</div>
            </li>
            <li>
                <div class="message-center">
                    {#each notifications as notif}
                        <a on:click={() => changeViewed(notif.id)} href="{notif.url}">
                            <div class="btn btn-{notif.state} btn-circle">
                                <img class="silot" src={notif.icon} width="30">
                                <div class="notify">
                                    {#if !notif.viewed}
                                        <span class="heartbit"></span>
                                        <span class="point"></span>
                                    {/if}
                                </div>
                            </div>
                            <div class="mail-contnet">
                                <h5>{notif.title}</h5> <span class="mail-desc">{notif.description}</span> <span
                                    class="time">{notif.time}</span>
                            </div>
                        </a>

                    {/each}
                </div>
            </li>
            <li>
                <a class="nav-link text-center" href="#/alerts"> <strong>Check all notifications</strong> <i
                        class="fa fa-angle-right"></i> </a>
            </li>
        </ul>
    </div>
</li>